import React from 'react';
import { useEffect, useState } from 'react'
import {
  SDrawerOrModal,
} from 'shj-components'
import { Form, Input, DatePicker } from 'antd';
import dayjs from 'dayjs';

export default function ChangeDeliveryTimeModal ({
  editId= '',
  open = false,
  basicInfo = {},
  onClose = () => {},
  reload = () => {},
})  {
  const [ form ] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      doorNo: (basicInfo as any)?.houseInfo?.doorNo,
      handoverDate: (basicInfo as any)?.houseInfo?.handoverDate,
      layout: (basicInfo as any)?.houseInfo?.layout,
      innerArea: (basicInfo as any)?.houseInfo?.innerArea,
      designStyleCode: (basicInfo as any)?.dtlInfo?.designStyleCode,
      budget: (basicInfo as any)?.dtlInfo?.budget,
    })
  }, []);

  const onSubmit = () => {
    form.validateFields().then(async (values: any) => {
      try {
        setLoading(true);
        // const res: any = await confirmArrive({ trackPlanId: editId, buttonKey, ...values })
        setLoading(false);
        // if (res.errorCode === 0 && res.status) {
        //   message.success('确认到店成功');
        //   onClose();
        //   reload();
        // } else {
        //   message.error('确认到店失败');
        // }
      } catch(err) {
        setLoading(false);
        console.log(err)
      }
    })
  }

  return (
    <div>
      <SDrawerOrModal
        mode="modal"
        open={open}
        width={600}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        title="变更交房时间"
      >
        <Form
          form={form}
          name="basicInfo"
          layout="vertical"
        >
          <Form.Item
            name="arrivalType"
            label="房屋状态"
            style={{
              width: '100%'
            }}
          >
            <Input placeholder={'请输入房屋状态'} disabled/>
          </Form.Item>
          <Form.Item
            name="handoverDate"
            label="交房时间"
            rules={[
              {
                required: true,
                message: '请选择交房时间',
              },
            ]}
            getValueProps={(value) => ({
              value: value && dayjs(Number(value)),
            })}
            normalize={(value) => value && `${dayjs(value).valueOf()}`}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}